/* AUTOGENERATED FILE - DO NOT EDIT CONTENTS */

export const projectId = "gujyufrdumeossjsluuc"
export const publicAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd1anl1ZnJkdW1lb3NzanNsdXVjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzE5NDE4OTksImV4cCI6MjA4NzUxNzg5OX0.xl4NldsRPrvJvvBSdsAHFVP44zgdoZQVVk91Ydd6U9c"